import { createRequestTypes } from '../utils';

export const RAWMAT_SUPPLIER_LIST = createRequestTypes('rawMatSupplier/RAWMAT_SUPPLIER_LIST');
